import Link from 'components/Globals/Base/Link';
import { withErrorBoundary } from 'components/ErrorBoundary';
import { UIFragments } from 'utils/log/constants/uiFragments';
import * as S from './RankingListsTabsStyles';

export interface RankingListsTabsProps {
  className?: string;
  tabs: {
    title: string;
    cta: {
      title: string;
      url: string;
    };
    items: {
      name: string;
      slug?: string;
      location?: string;
    }[];
  }[];
}

const getAnchorProps = (slug?: string) => (slug ? { as: 'a', className: 'is-anchor', href: slug } : {});

const RankingListsTabs = ({ tabs, className }: RankingListsTabsProps) => (
  <S.RankingListsTabs
    className={className}
    config={tabs.map(({ title, items, cta }) => ({
      children: (
        <>
          <ul>
            {items.map(({ slug, name, location }, index) => (
              <S.RankingItem
                // eslint-disable-next-line react/no-array-index-key
                key={`${name}-${index}`}
                $rank={index + 1}
                {...getAnchorProps(slug)}
              >
                {name}
                {location && <address>{location}</address>}
              </S.RankingItem>
            ))}
          </ul>
          {cta && cta.url && (
            <Link
              type='primaryBrandButton'
              href={cta.url}
            >
              {cta.title}
            </Link>
          )}
        </>
      ),
      title,
    }))}
    defaultIndex={0}
    dropdownMobile
    enableTabsSlider
  />
);

export default withErrorBoundary(RankingListsTabs, { fragment: UIFragments.EDU_RANKINGS_SECTION });
